import type { MaybeRef } from "vue"
import type { ServerResponse } from "@/http"
import type { IPaymentInfoResponse } from "@/types"
import { useQuery } from "@tanstack/vue-query"
import { toValue } from "vue"
import { axios } from "@/axios"
import { PaymentInfo } from "@/models"

export async function getPaymentInfo(token: string, email: string, packageSubscriptionId?: string) {
  const response = await axios.get<ServerResponse<IPaymentInfoResponse>>(`api/event/payment/${token}`, {
    params: {
      email: encodeURIComponent(email),
      packageSubscriptionId,
    },
  })

  return PaymentInfo.fromResponse(response.data.Data)
}

export function useGetPaymentInfo(token?: MaybeRef<string>, email?: MaybeRef<string>, packageSubscriptionId?: MaybeRef<string>) {
  const tokenValue = toValue(token)
  const emailValue = toValue(email)

  return useQuery({
    queryKey: ["getPaymentInfo", token, email],
    queryFn: () => getPaymentInfo(tokenValue!, emailValue!, toValue(packageSubscriptionId)),
    enabled: !!tokenValue && !!emailValue,
  })
}
